export function sanitizeNextPath(value: string | null | undefined) {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return null;
  }

  // Browsers treat backslashes as URL separators in some contexts.
  if (value.includes("\\")) return null;

  try {
    const base = "https://fireflies.local";
    const parsed = new URL(value, base);
    if (parsed.origin !== base) return null;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}

export function currentInternalPath() {
  return sanitizeNextPath(
    `${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

export function authPath(path: "/login" | "/register", next?: string | null) {
  const safeNext = sanitizeNextPath(next);
  return safeNext ? `${path}?next=${encodeURIComponent(safeNext)}` : path;
}
